module.exports = __webpack_public_path__ + "img/closing.4b1a2d6b.svg";